const valuePropsSlideshowOptions = {
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  speed: 500,
  mobileFirst: true,
  autoplay: true,
  autoplaySpeed: 3 * 1000,
  dots: false,
  arrows: false,
  adaptiveHeight: false,
  responsive: [
    {
      breakpoint: 1023,
      settings: 'unslick'
    }
  ]
};
const vpSlideshow = document.querySelector(
  '.section-value-props .slideshow__slides'
);

$(vpSlideshow).slick(valuePropsSlideshowOptions);

function removeSlideShowDesktopAriaAttributes() {
  if (!vpSlideshow) return;
  if (window.innerWidth >= 1024) {
    vpSlideshow.removeAttribute('aria-label');
    vpSlideshow.removeAttribute('role');
  }
}

window.addEventListener('load', function () {
  // change the aria label for desktop
  removeSlideShowDesktopAriaAttributes();
});

window.addEventListener('resize', function () {
  if (!vpSlideshow) return;
  if (
    window.innerWidth < 1024 &&
    !vpSlideshow.classList.contains('slick-initialized')
  ) {
    $(vpSlideshow).slick(valuePropsSlideshowOptions);
  }
  // change the aria label for desktop
  removeSlideShowDesktopAriaAttributes();
});
